import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {AppModule} from './app/app.module';
import {environment} from './environments/environment';
import {Capacitor} from '@capacitor/core';

if (environment.production) {
  enableProdMode();
}

// Firebase initialization - Optional (disabled if useFirebase is false)
if (!Capacitor.isNativePlatform() && (environment as any).useFirebase !== false) {
  import('firebase/app')
    .then(({initializeApp}) => {
      initializeApp(environment.firebase);
      console.log('✅ Firebase initialized');
    })
    .catch(error => {
      console.warn('⚠️ Firebase not available, continuing without Firebase:', error);
    });
} else {
  console.log('ℹ️ Firebase initialization skipped (useFirebase: false)');
}

function bootstrap() {
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch(err => console.error(err));
}

if (document.readyState === 'complete') {
  bootstrap();
} else {
  document.addEventListener('DOMContentLoaded', bootstrap);
}
